import { cva, type VariantProps } from 'class-variance-authority';
import styles from './chip.module.scss';

export const outlineVariants = {
  filled: styles.filled,
  outlined: styles.outlined
};

export const sizeVariants = {
  small: styles.small,
  medium: styles.medium
};

const ChipClass = cva(styles.chip, {
  variants: {
    outline: outlineVariants,
    size: sizeVariants,
    button: {
      true: styles.button
    }
  },
  defaultVariants: {
    outline: 'filled',
    size: 'medium'
  }
});

type ChipProps = VariantProps<typeof ChipClass> & {
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
  style?: React.CSSProperties;
};

export default function Chip({
  className,
  children,
  outline,
  size = 'medium',
  onClick,
  style
}: ChipProps) {
  if (onClick) {
    return (
      <button
        onClick={onClick}
        className={ChipClass({ className, outline, size, button: true })}
        style={style}
      >
        {children}
      </button>
    );
  }

  return (
    <div className={ChipClass({ className, outline, size })} style={style}>
      {children}
    </div>
  );
}
